<template>
    <b-card no-body>
        <b-card-header>
            <h5 class="mb-0 text-white"><b>FILTROS</b></h5>
        </b-card-header>
        <b-card-body class="pt-2">
            <b-row>

                <b-col
                    cols="12"
                    md="4"
                    class="mb-2"
                >
                    <label for="courseTypes"><strong>TIPO(S) DE SERVICIO</strong></label>
                    <v-select
                        id="courseTypes"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        multiple
                        v-model="formData.courseTypesArray"
                        :options="options.courseTypes"
                        class="w-100"
                        @input="inputCourseTypesVal()"
                    />
                </b-col>

                <b-col
                    cols="12"
                    md="4"
                    class="mb-2"
                >
                    <label for="courseTypes"><strong>¿PUBLICADO?</strong></label>
                    <v-select
                        id="publications"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        multiple
                        v-model="formData.publicationsArray"
                        :options="options.publications"
                        class="w-100"
                        @input="inputPublicationsVal()"
                    />
                </b-col>

            </b-row>

        </b-card-body>
    </b-card>
</template>

<script>

    import { ref } from '@vue/composition-api';
    import vSelect from 'vue-select';

    export default {
        components: {
            vSelect
        },
        props: {
            options: {
                type: Object,
                required: true
            }
        },
        setup(props, { emit }) {

            // REFS
            const formData = ref({
                courseTypesArray: [],
                publicationsArray: []
            });

            const inputCourseTypesVal = () => {
                if (formData.value.courseTypesArray)
                {
                    const array = formData.value.courseTypesArray.map(item => item.value);
                    emit('update:courseTypesFilter', array.join(','));

                    return array;
                }

                return null;
            };

            const inputPublicationsVal = () => {
                if (formData.value.publicationsArray)
                {
                    const array = formData.value.publicationsArray.map(item => item.value);
                    emit('update:publicationsFilter', array.join(','));

                    return array;
                }

                return null;
            };

            return {
                // DATA
                formData,

                // METHODS
                inputCourseTypesVal,
                inputPublicationsVal
            }

        }
    }

</script>

<style lang="scss" scoped>

    .card-header {
        background-color: var(--primary);
        padding: 1rem 1.5rem;
    }

</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
